import React, { useEffect, useState } from "react";
// Assuming you have a logo image in the 'assets' folder or 'public' folder
import logo from "../../assets/images/le-logo.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const GeneratePassword = () => {
  const [searchParams] = useSearchParams();
  const dataVal = searchParams.get("data");
  const [userName, setUserName] = useState("");
  const [compntVisible, setCompntVisible] = useState(false);
  const [newPwd, setNewPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [errors, setErrors] = useState("");
  const [otpVal, setOtpVal] = useState(null);
  const [decodes, setDecodes] = useState([]);
  const [otpVisible, setOtpVisible] = useState(false);
  const [error, setError] = useState("");
  const [isToken, setIsToken] = useState(false);
  const [pwdValidation, setPwdValidation] = useState({
    newpwd: "",
    confirmpwd: "",
  });
  let track = false;
  const navigate = useNavigate();

  const API_URI = process.env.REACT_APP_BASE_URL;

  const checkUser = async (id) => {
    try {
      const response = await fetch(`${API_URI}generatepassword.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Set content type to JSON
        },
        body: JSON.stringify({
          type: "checkUser",
          id: Number(id),
          email: decodes.email,
        }),
      });

      const data = await response.json();
      if (Number(data) === 0) {
        setCompntVisible(false);
        navigate("/login");
        // return null;
      } else {
        setCompntVisible(true);
      }

      // console.log("checkuser", data);
    } catch (error) {
      console.error("Error submitting form:", error); // Handle errors
    }
  };

  const sendData1 = async () => {
    try {
      const response = await fetch(`${API_URI}generatepassword.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Set content type to JSON
        },
        body: JSON.stringify({
          type: "triggerotp",
          id: Number(decodes.userid),
          email: decodes.email,
        }),
      });

      const data = await response.json();
    } catch (error) {
      console.error("Error submitting form:", error); // Handle errors
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    track = false;
    try {
      if (otpVal === null) {
        toast.error("The OTP you entered is invalid. Please try again.", {
          position: "top-center",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          className: "login-toast",
        });
        // alert("The OTP you entered is invalid. Please try again.");
      } else {
        if (newPwd.trim() === "") {
          track = true;
          setPwdValidation((prev) => ({
            ...prev,
            newpwd: "(Password is required)",
          }));
        }
        if (confirmPwd.trim() === "") {
          track = true;
          setPwdValidation((prev) => ({
            ...prev,
            confirmpwd: "(Confirm password is required)",
          }));
        }
        if (Object.entries(errors).length != 0) {
          track = true;
        }
        if (!track) {
          if (newPwd.trim() === confirmPwd.trim()) {
            const response = await fetch(`${API_URI}generatepassword.php`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json", // Set content type to JSON
              },
              body: JSON.stringify({
                type: "checkotp",
                val: Number(otpVal),
                id: Number(decodes.userid),
                val1: confirmPwd,
              }),
            });
            const data = await response.json();
            if (data.success) {
              navigate("/login");
            } else {
              toast.error("The OTP you entered is invalid. Please try again.", {
                position: "top-center",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
                className: "login-toast",
              });
              // alert("The OTP you entered is invalid. Please try again.");
            }
          } else {
            setPwdValidation((prev) => ({
              ...prev,
              confirmpwd: "(Your passwords don't match. Please try again)",
            }));
          }
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error); // Handle errors
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPwd.trim() === "") {
      track = true;
      setPwdValidation((prev) => ({
        ...prev,
        newpwd: "(Password is required)",
      }));
    }
    if (confirmPwd.trim() === "") {
      track = true;
      setPwdValidation((prev) => ({
        ...prev,
        confirmpwd: "(Confirm password is required)",
      }));
    }
    if (Object.entries(errors).length != 0) {
      track = true;
    }
    if (!track) {
      if (newPwd.trim() === confirmPwd.trim()) {
        toast.info(
          "We’ve sent a One-Time Password to your email. Please enter it to complete the process..",
          {
            position: "top-center",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
            className: "login-toast",
          }
        );
        // alert(
        //   "We’ve sent a One-Time Password to your email. Please enter it to complete the process."
        // );
        sendData1();
        setOtpVisible(true);
      } else {
        setPwdValidation((prev) => ({
          ...prev,
          confirmpwd: "(Your passwords don't match. Please try again)",
        }));
      }
    }
  };
  const verifyToken = async (tkn) => {
    try {
      const response = await fetch(`${API_URI}forgot-password.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Set content type to JSON
        },
        body: JSON.stringify({
          token: tkn,
          type: "checktoken",
        }),
      });
      const data = await response.json();
      if (data.success) {
        //  setIsValid(true);
        setIsToken(true);
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError("Something went wrong");
    }
  };
  function decryptUrl(encryptedData) {
    // Decode the URL-safe Base64 string
    const decodedData = decodeURIComponent(encryptedData);
    // Decode Base64 to a JSON string
    const jsonString = atob(decodedData);
    // Parse the JSON string into an object
    return JSON.parse(jsonString);
  }
  useEffect(() => {
    // alert("test");
    console.log("datavalue", dataVal);
    if (dataVal) {
      const decode = decryptUrl(dataVal);
      setDecodes(decode);
      setUserName(decode.username);
      checkUser(decode.userid);
      if (decode.hasOwnProperty("token")) {
        verifyToken(decode.token);
      } else {
        setIsToken(true);
      }
      console.log("dec", decode);
      //sendData();
    } else {
      navigate("/login");
      //return null;
    }
  }, []);

  const handleNewPwd = (e) => {
    let value = e.target.value;
    setPwdValidation((prev) => ({
      ...prev,
      newpwd: "",
    }));
    setNewPwd(value);
    // Define validation criteria
    const validations = {
      length: value.length >= 8,
      specialChar: /[@$!%*?&]/.test(value),
      uppercase: /[A-Z]/.test(value),
      number: /\d/.test(value),
    };

    // Check if all validations pass
    const allValid = Object.values(validations).every(Boolean);

    if (allValid) {
      setErrors({});
    } else {
      // Create feedback messages
      const feedback = {
        length: validations.length
          ? "Password length is sufficient"
          : "Password must be at least 8 characters long",
        specialChar: validations.specialChar
          ? "Special character included"
          : "Include at least one special character",
        uppercase: validations.uppercase
          ? "Uppercase letter included"
          : "Include at least one uppercase letter",
        number: validations.number
          ? "Number included"
          : "Include at least one number",
      };
      setErrors(feedback);
    }
  };
  const handleConfirmPwd = (e) => {
    setPwdValidation((prev) => ({
      ...prev,
      confirmpwd: "",
    }));
    setConfirmPwd(e.target.value);
  };
  const labelStyles = {
    fontWeight: "600",
    marginBottom: "8px",
    fontSize: "14px",
  };
  const invalidFeedbackStyle = {
    color: "red",
    fontSize: "12px",
    marginTop: "-8px",
    marginBottom: "10px",
  };
  console.log("statuscheck", compntVisible);
  if (!compntVisible) {
    return null;
  }

  return (
    <div
      className="content"
      style={{ backgroundColor: "#f8fafb", minHeight: "100vh" }}
    >
      <ToastContainer
        position="top-center"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="col-md-6">
          <div className="card shadow-lg border-0 rounded-lg">
            <div className="card-body">
              <div className="text-center mb-4">
                <img
                  src={logo}
                  alt="logo"
                  className="img-fluid"
                  style={{ maxHeight: "60px" }}
                />
              </div>
              <h3 className="form-header text-center mb-4">
                Generate Password
              </h3>
              {isToken ? (
                <form onSubmit={otpVisible ? handleOtpSubmit : handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="username" style={labelStyles}>
                      User Name:
                    </label>
                    <div
                      id="username"
                      style={{
                        width: "100%",
                        padding: "8px",
                        marginBottom: "15px",
                        borderRadius: "4px",
                        border: "1px solid #ced4da",
                        fontSize: "14px",
                        color: "var(--gray-700)",
                      }}
                    >
                      {userName}
                    </div>
                    <label htmlFor="newpassword" style={labelStyles}>
                      New Password:<span className="requireds">*</span>
                      {pwdValidation.newpwd && (
                        <span className="fieldValidation">
                          {pwdValidation.newpwd}
                        </span>
                      )}
                    </label>
                    <input
                      id="newpassword"
                      type="password"
                      placeholder="Enter your new password"
                      value={newPwd}
                      onChange={handleNewPwd}
                      style={{
                        width: "100%",
                        padding: "8px",
                        marginBottom: "15px",
                        borderRadius: "4px",
                        border: "1px solid #ced4da",
                        fontSize: "14px",
                      }}
                    />
                    {errors && (
                      <div style={invalidFeedbackStyle}>
                        {Object.entries(errors).map(([key, message]) => (
                          <p
                            key={key}
                            style={{
                              color:
                                message.includes("included") ||
                                message.includes("sufficient")
                                  ? "#0dc10d"
                                  : "red",
                              margin: "5px 0",
                            }}
                          >
                            {message}
                          </p>
                        ))}
                      </div>
                    )}
                    <label htmlFor="confirmpassword" style={labelStyles}>
                      Confirm Password:<span className="requireds">*</span>
                      {pwdValidation.confirmpwd && (
                        <span className="fieldValidation">
                          {pwdValidation.confirmpwd}
                        </span>
                      )}
                    </label>
                    <input
                      id="confirmpassword"
                      type="password"
                      placeholder="Enter your confirm password"
                      value={confirmPwd}
                      onChange={handleConfirmPwd}
                      style={{
                        width: "100%",
                        padding: "8px",
                        marginBottom: "15px",
                        borderRadius: "4px",
                        border: "1px solid #ced4da",
                        fontSize: "14px",
                      }}
                    />
                    {otpVisible && (
                      <input
                        id="otp"
                        type="number"
                        placeholder="Enter your OTP Here!"
                        value={otpVal}
                        onChange={(e) => setOtpVal(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px",
                          marginBottom: "15px",
                          borderRadius: "4px",
                          border: "1px solid #ced4da",
                          fontSize: "14px",
                        }}
                      />
                    )}

                    <button
                      type="submit"
                      className="submit-btn"
                      style={{
                        padding: "10px 20px",
                        border: "none",
                        backgroundColor: "#007bff",
                        color: "#fff",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "16px",
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              ) : null}
              {error && <div className="alert alert-danger mt-3">{error}</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneratePassword;
